import { render, staticRenderFns } from "./details_ddt_manager.vue?vue&type=template&id=44e78d37&"
import script from "./details_ddt_manager.vue?vue&type=script&lang=js&"
export * from "./details_ddt_manager.vue?vue&type=script&lang=js&"
import style0 from "./details_ddt_manager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports